import React from 'react';
import OptionButton from '../OptionButton';

const Step9 = ({ data, onSelect, overrides }) => {
  const options = overrides?.options || [
    'Very important',
    'Somewhat important',
    'Not important',
    'Not sure'
  ];

  return (
    <div className="flex flex-col">
      {/* Question */}
      <h1 className="font-serif text-4xl md:text-5xl leading-tight mb-8" style={{ color: '#1a1a2e' }}>
        {overrides?.question || 'When choosing a thyroid supplement, how important is clinical research to you?'}
      </h1>

      {/* Options */}
      <div className="flex flex-col gap-3 items-start">
        {options.map((option) => (
          <OptionButton
            key={option}
            selected={data.clinicalImportance === option}
            onClick={() => onSelect('clinicalImportance', option)}
          >
            {option}
          </OptionButton>
        ))}
      </div>
    </div>
  );
};

export default Step9;
